const icons = require('./icon')

const publicOptions = {
  isMore: false,
  hasMore: false,
  moreTitle: '展开'
}

const SELECTED_LIST = [
  {
    ...publicOptions,
    name: '国家/地区',
    icon: icons.countryIcon,
    prop: 'country',
    tagList: [
      { name: '中国', value: 'China' },
      { name: '中国港澳台', value: 'USA' },
      { name: '美国', value: 'JP' },
      { name: '英国', value: 'en' },
      { name: '德国', value: 'Ger' },
      { name: '澳大利亚', value: 'au' },
      { name: '马来西亚', value: 'mc' },
      { name: '北美', value: 'nm' },
      { name: '父辈的旗帜', value: 'f' },
      { name: '日本', value: 'jp' },
      { name: '一个月内', value: 'qh' },
      { name: '阿里恩中教', value: 'mid' },
      { name: '盲井', value: 'mj' },
      { name: '天狗', value: 'tg' }
    ]
  },
  {
    ...publicOptions,
    name: '交易类型',
    icon: icons.dealIcon,
    tagList: [
      { name: '许可', value: 'pass' },
      { name: '转让', value: 'transform' },
      { name: '待转化', value: 'willtransform' }
    ]
  },
  {
    ...publicOptions,
    name: '成果类型',
    icon: icons.resultIcon,
    tagList: [
      { name: '发明专利', value: 'Edward Chan' },
      { name: '实用新型', value: 'Hins Cheung' },
      { name: '外观设计', value: 'Phil Lam' },
      { name: '商标', value: 'Shiga Lin' }
    ]
  },
  {
    ...publicOptions,
    name: '价格',
    icon: icons.priceIcon,
    tagList: [
      { name: '1万', value: '1' },
      { name: '1-2万', value: '1-2' },
      { name: '5万以上', value: '5' },
      {
        isCustom: true,
        typeName: 'LabelAndInput',
        name: '价格范围',
        value: 'Sammi Cheng'
      }
    ]
  },
  {
    ...publicOptions,
    name: '发布时间',
    icon: icons.timeIcon,
    tagList: [
      { name: '今天', value: 'today' },
      { name: '三天内', value: '3days' },
      { name: '一周内', value: 'week' },
      { name: '一个月内', value: 'month' }
    ]
  }
]

module.exports = {
  SELECTED_LIST
}
